module.exports = __webpack_public_path__ + "assets/img/bhelp1.37b7d4ea.png";